package com.eladfinish.bible.contest.features.verseWidget

/**
 * What the shared code needs from the platform's widget system: to ask for a widget to be added, to count
 * the ones on the home screens, and to tell the widget that the settings changed. The tile and the screen
 * exist only on Android and iOS (see [isVerseWidgetPlatform]). Android and iOS each implement it
 * where their widget lives; every other platform has [UnsupportedVerseWidgetHost].
 */
interface VerseWidgetHost {

    /** Whether the app can ask the system to add the widget to the home screen (iOS cannot, and Android launchers may not). */
    val canRequestPin: Boolean

    /** Asks the system to add the widget to the home screen. @return whether the system's dialog was shown. */
    fun requestPin(): Boolean

    /** How many widgets are on the home screens, or `null` when the platform cannot tell. */
    fun installedCount(): Int?

    /** Tells the widget the settings changed so that it shows the verse of the new settings now. */
    fun onConfigChanged(config: VerseWidgetConfig)

    /**
     * The settings screen is on screen. A platform whose widget cannot make its own verses (iOS) makes sure they
     * are ready now, so that a widget added from here shows a verse at once.
     */
    fun onSettingsShown() = Unit
}

object UnsupportedVerseWidgetHost : VerseWidgetHost {
    override val canRequestPin = false
    override fun requestPin() = false
    override fun installedCount(): Int? = null
    override fun onConfigChanged(config: VerseWidgetConfig) = Unit
}
